// import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Hero from './Components/Hero';
import Navbar from './Components/Navbar';
import Pricing from './Components/Pricing';
import Gallary from './Components/Gallary';
import ContactForm from './Components/ContactForm';
import Footer from './Components/Footer';

function App() {
  return (
    <div className="App">
       <Navbar />
       <Hero/>
       <Pricing/>
       <Gallary/>
       <ContactForm/>
       <Footer/>
       
    </div>
  );
}

export default App;
